import Vue from 'vue'
import Router from 'vue-router'
import RouterShell from './shell'
import RouterAuth from './auth'
Vue.use(Router)

const allRouterArr = []
const routersList = allRouterArr.concat(RouterShell, RouterAuth)
export default new Router({
  mode: 'history',
  base: '/', // 非常重要
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop;
      }
      return { x: 0, y: to.meta.savedPosition || 0 }
    }
  },
  routes: routersList
})



// WEBPACK FOOTER //
// ./src/routers/index.js